<template>
    <div class="card canvas-element" :class="{expanded, additional, uploaded: !in_progress}">
        <div class="card-header d-flex justify-content-between align-items-center"
             :title="in_progress ? 'In Progress' : ''"
             @click="toggleExpand">
            <div>
                <icon-plus-plus v-if="additional" color="dark" size="16" class="mr-1" />
                <icon-check v-else-if="uploaded" color="dark" size="16" class="mr-1" fill="" />
                <icon-clock v-else-if="in_progress" color="dark" size="16" class="mr-1" />
                {{ item.element ? item.element.name : 'Additional submissions' }}
            </div>
            <icon-chevron-right class="opener" size="16" color="dark" />
        </div>
        <div class="card-body" v-if="expanded">
            <a v-for="(upload, idx) in canvas_uploads" :key="upload.id"
               :href="uploads.url(upload.file.url)"
               class="d-flex align-items-center"
               target="_blank">
                <span class="number">{{ idx + 1 }}</span>
                {{ upload_titles[ idx ].title }}
            </a>
        </div>
    </div>
</template>

<script>
import utils from "@/mixins/utils";
import IconChevronRight from "@/Icons/IconChevronRight";
import IconClock from "@/Icons/IconClock";
import uploads from "@/mixins/uploads";
import IconCheck from "@/Icons/IconCheck";
import IconPlusPlus from "@/Icons/IconPlusPlus";
import API from "@/API";
export default {
    name: "CanvasElement",
    components: {IconPlusPlus, IconCheck, IconClock, IconChevronRight},
    mixins: [utils, uploads],
    props: ['item'],


    data(){
        return {
            expanded: false,
            upload_titles: [],
        }
    },

    computed: {
        element(){
            return this.item.element;
        },
        canvas_uploads(){
            return this.item.canvas_data.uploads;
        },
        in_progress(){
            return !this.uploaded;
        },
        uploaded(){
            return !!this.canvas_uploads.length;
        },
        additional(){
            return !this.item.element;
        }
    },


    methods: {
        toggleExpand(){
            if( !this.canvas_uploads.length ) return;
            this.expanded = !this.expanded;
        },
    },

    mounted() {
        if( this.canvas_uploads.length ){
            for( const i in this.canvas_uploads ){
                this.upload_titles.push({
                    id: this.canvas_uploads[i].id,
                    title: this.utils.ellipsis( this.canvas_uploads[i].file ? this.canvas_uploads[i].file.name : "", 10, 5 ),
                    uploaded_by_id: this.canvas_uploads[i]?.file?.uploaded_by_id ? this.canvas_uploads[i]?.file?.uploaded_by_id : null,
                });

                if( this.canvas_uploads[i]?.file?.uploaded_by_id ){
                    API.users
                        .getCached( this.canvas_uploads[i]?.file?.uploaded_by_id )
                        .then((user) => {
                            const title = [user.first_name, user.last_name].join(' ');
                            this.upload_titles.filter(t => t.uploaded_by_id === user.id )
                                .map(u => u.title = title);
                        })
                }
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.number{
    display: flex;
    flex: 0 0 1.5rem 1.5rem;
    width: 1.5rem;
    height: 1.5rem;
    align-items: center;
    justify-content: center;
    background: $dark;
    color: white;
    border-radius: 50%;
    margin-right: 0.6rem;
}
.card-header{
    padding: 0.6rem;
    cursor: pointer;
}

.card-body{
    padding: 0.6rem;

    a{
        text-decoration: none;
        color: $feel;
        margin-bottom: 0.3rem;

        &:last-child{
            margin-bottom: 0;
        }
    }
}

.opener{
    transition: transform .3s;
}


.canvas-element{

    &.expanded{
        .opener{
            transform: rotateZ(90deg);
        }
    }

    &:not(.expanded){
        .card-header{
            border-bottom: none;
            border-radius: $card-border-radius;
        }
    }

    &.uploaded{
        .card-header{
            background: lighten($success, 25%);
        }
    }

    &:not(.uploaded){
        .card-header{
            cursor: default;
        }

        .opener{
            display: none;
        }

    }

    &.additional{
        .card-header{
            background: lighten($primary, 25%);
        }
    }
}

</style>
